import { defineStore } from "pinia"
import { IContact } from "@/models/contacts/contact.types"
import phoneNumberValidator from "@/validators/phoneNumber"

let resolveAnswer: (() => void) | null = null

const offeredKey = (contact: IContact, phoneNumber: string) =>
  `${contact.juniferContactId}:${phoneNumber}`

/*
  Lets the installation essentials Next action ask the agent whether to save
  the number they entered to the customer's contact details, and wait for
  their answer before the flow moves on.
*/
export const useImbpSaveContactNumberPromptStore = defineStore(
  "imbpSaveContactNumberPrompt",
  {
    state: () => ({
      phoneNumber: "",
      contact: null as IContact | null,
      offered: [] as string[],
    }),
    getters: {
      isOpen: (state) => state.contact !== null,
    },
    actions: {
      // Only for an account with no number on file, and once per number
      shouldOffer(contact: IContact | null | undefined, phoneNumber: string) {
        if (!contact || contact.phone1?.trim() || contact.phone2?.trim()) {
          return false
        }
        return (
          !!phoneNumber &&
          phoneNumberValidator(phoneNumber) === true &&
          phoneNumber !== contact.phone3?.trim() &&
          !this.offered.includes(offeredKey(contact, phoneNumber))
        )
      },
      ask(contact: IContact, phoneNumber: string): Promise<void> {
        this.offered.push(offeredKey(contact, phoneNumber))
        this.$patch({ contact, phoneNumber })
        return new Promise((resolve) => {
          resolveAnswer = resolve
        })
      },
      answered() {
        // phoneNumber is kept so the modal text doesn't blank while it fades out
        this.contact = null
        resolveAnswer?.()
        resolveAnswer = null
      },
    },
  },
)
